import { Link, Map } from '@schuettflix/react-components';
import { environment } from '@/environment.ts';
import { ChevronRightIcon } from '@schuettflix/icons-react';
import { useTranslation } from 'react-i18next';
import { Coordinates } from '@/modules/location/domain/GeoAddressSchema.ts';
import React, { useState } from 'react';
import { TransferPointPanel } from './TransferPointPanel.tsx';
import { cn } from '@/shared/utils/cn.ts';

type TransferPointProps = {
    transferPoint: Coordinates;
    onChange: (transferPoint: Coordinates) => void;
    disabled?: boolean;
};

export const TransferPoint: React.FC<TransferPointProps> = (props: TransferPointProps) => {
    const { t, i18n } = useTranslation();
    const [showPanel, setShowPanel] = useState(false);

    const zoomLevel = 19;

    return (
        <>
            <div
                className={cn(!props.disabled && 'cursor-pointer')}
                onClick={() => {
                    if (props.disabled) return;
                    setShowPanel(true);
                }}
                onKeyDown={e => {
                    if (props.disabled) return;
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        setShowPanel(true);
                    }
                }}
            >
                <Map
                    className="mb-4 min-h-[150px] rounded-md"
                    apiKey={environment.GOOGLE_MAPS_API_KEY}
                    language={i18n.language}
                    center={{
                        latitude: props.transferPoint.latitude,
                        longitude: props.transferPoint.longitude,
                    }}
                    zoom={zoomLevel}
                    mapType="hybrid"
                    gestureHandling="none"
                />
                <Link
                    suffix={<ChevronRightIcon size="xs" />}
                    tabIndex={0}
                    className="font-copy-md-strong mb-2 pt-1"
                    label={t('location.newAddress.loadingSpecification.linkText')}
                    disabled={props.disabled}
                />
                <p className="font-copy-md">{t('location.newAddress.loadingSpecification.linkDescription')}</p>
            </div>
            {showPanel && (
                <TransferPointPanel
                    apiKey={environment.GOOGLE_MAPS_API_KEY}
                    language={i18n.language}
                    transferPoint={props.transferPoint}
                    zoomLevel={zoomLevel}
                    onClose={() => {
                        setShowPanel(false);
                    }}
                    onSubmit={transferPoint => {
                        setShowPanel(false);
                        props.onChange(transferPoint);
                    }}
                />
            )}
        </>
    );
};
